export const namespaced = true;

export const state = {
    localStorageName: 'flightsInfo',
    flightsInfo: [],
}

export const mutations = {
    ADD_TO_FLIGHTS_INFO(state, payload){
        state.flightsInfo.push(payload);
    },
}

export const actions = {
    addToFlightsInfo(context, payload){
        context.commit('ADD_TO_FLIGHTS_INFO', payload);
    }
}

export const getters = {}